import React, { useMemo } from "react";
import { FieldConfig, FormFieldType } from "../../../api/formConfigs";

interface DocumentDetailsFieldBlockProps {
  field: FieldConfig;
  value: any;
}

const DocumentDetailsFieldBlock: React.FC<DocumentDetailsFieldBlockProps> = ({
  field,
  value,
}) => {
  const isFullWidth = useMemo(() => {
    return field.field_type === FormFieldType.TEXT_AREA;
  }, [field]);

  const displayValue = useMemo(() => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }

    if (field.field_type === FormFieldType.SELECT || field.field_type === FormFieldType.RADIOBUTTON) {
      const matchedOption = field.options?.find((opt) => String(opt.value) === String(value));
      if (matchedOption) return matchedOption.label;
    }

    if (field.field_type === FormFieldType.MULTISELECT && Array.isArray(value)) {
      const matchedLabels = value.map((val) => {
        const matchedOption = field.options?.find((opt) => String(opt.value) === String(val));
        return matchedOption ? matchedOption.label : String(val);
      });
      return matchedLabels.join(", ");
    }

    if (Array.isArray(value)) {
      return value.join(", ");
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    return String(value);
  }, [value, field]);

  return (
    <div
      className={`
        rounded-[6px]
        bg-[#F3F4F6]
        px-2
        py-1.5
        flex
        flex-col
        gap-0.5
        min-w-0
        ${isFullWidth ? "col-span-2 h-auto" : "col-span-1 h-[50px] justify-center"}
      `}
    >
      <span className="text-[12px] font-normal leading-4 text-[#737373] truncate block">
        {field.label}
      </span>
      <span
        title={displayValue}
        className={`
          text-[14px] 
          font-medium 
          leading-5 
          text-[#0A0A0A] 
          block 
          min-w-0 
          w-full
          ${isFullWidth ? "break-words" : "truncate"}
        `}
      >
        {displayValue}
      </span>
    </div>
  );
};

export default DocumentDetailsFieldBlock;